export const SurveySvg = () => {
  return (
    <svg
      width="25"
      height="30"
      viewBox="0 0 39 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="me-3"
    >
      <path
        d="M25.8676 4.43774H38.4802V50.56H36.5876H1V4.43774H13.5992"
        stroke="#3F4254"
      />
      <path d="M32.141 22.9924H22.3871H12.6333" stroke="#3F4254" />
      <path d="M32.141 31.7937H22.3871H12.6333" stroke="#3F4254" />
      <path d="M32.141 41.1238H22.3871H12.6333" stroke="#3F4254" />
      <path
        d="M4.50708 21.4708L6.69081 23.9324L10.1186 19.5386"
        stroke="#3F4254"
      />
      <path
        d="M4.50708 30.7745L6.69081 33.2362L10.1186 28.8423"
        stroke="#3F4254"
      />
      <path
        d="M4.50708 40.0914L6.69081 42.553L10.1186 38.1592"
        stroke="#3F4254"
      />
      <path
        d="M13.5992 4.42453C14.6977 2.13496 17.0402 0.560059 19.74 0.560059C23.4986 0.560059 26.5559 3.60401 26.5559 7.37585C26.5559 11.1477 23.5119 14.1916 19.74 14.1916C15.9682 14.1916 12.9243 11.1477 12.9243 7.37585C12.9243 6.31709 13.1757 5.32448 13.5992 4.42453Z"
        stroke="#3F4254"
      />
      <path d="M18.4695 4.43774L19.7399 7.37581H24.425" stroke="#3F4254" />
    </svg>
  );
};
